import res from './res'

res.add('ru', {
    title: 'Настройка таблицы',
    rowsCount: 'Количество строк на странице:',
    fieldsSettings: 'Настройка порядка отображения колонок',
    applyButton: 'Сохранить',
    cancelButton: 'Отменить'
})
